module.exports = __webpack_public_path__ + "media/images/icon_arrow-d874284bbe14fa27314e17168613bc16.svg";